import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Icon from "../MaterialIcon";

import { body, icon as iconStyle } from "./styles.module.scss";

const COLORS = {
  danger: "text-danger",
  success: "text-success"
};

const PlaceholderAlert = ({ icon, color, children }) => (
  <div className="py-4 d-flex flex-column align-items-center justify-content-center">
    <Icon
      name={icon}
      className={classNames(iconStyle, COLORS[color] || color)}
    />
    <div className={classNames(body, "mt-3 text-center")}>{children}</div>
  </div>
);

PlaceholderAlert.propTypes = {
  icon: PropTypes.string.isRequired,
  color: PropTypes.string,
  children: PropTypes.node
};

PlaceholderAlert.defaultProps = {
  color: "",
  children: null
};

export default PlaceholderAlert;
